/**
 * This holds multiple CategoryItemLists - it contains multiple categories and a list of items for each one.
 */
class CategoryItemListCollection {
    constructor() {
        /**
         * @type {Object<number, CategoryItemList>}
         */
        this.categories = {};

        /**
         * Total number of event buttons + non-event items in all the categories in this collection.
         *
         * @type {number}
         */
        this.count = 0;
    }

    /**
     * @param {CategoryItemList} categoryItemList
     */
    add(categoryItemList) {
        this.categories[categoryItemList.category.ID] = categoryItemList;
        this.count += categoryItemList.count;
    }
}

module.exports = CategoryItemListCollection;
